import axios from "../shared/axios";

export function getInternalEstimate(internalestimateid) {
  return axios.get(`/api/InternalEstimate/GetInternalEstimate?internalestimateid=${internalestimateid}`);
}

export function saveInternalEstimate(data) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/InternalEstimate/SaveInternalEstimate`, data)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => reject(error));
  });
}

export function updateInternalEstimate(data) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/InternalEstimate/UpdateInternalEstimate`, data)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => reject(error));
  });
}

export function markEstimateSuperseded(internalestimateid) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/InternalEstimate/MarkAsSuperseded?internalestimateid=${internalestimateid}`)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => reject(error));
  });
}

export function getInternalEstimateHistory(lineageid) {
  return axios.get(`/api/InternalEstimate/GetInternalEstimateHistory?lineageid=${lineageid}`);
}

export function getActiveEstimate(lineageid) {
  return axios.get(`/api/InternalEstimate/GetActiveEstimate?lineageid=${lineageid}`);
}
